import { MarkAsReadButton } from "@circle-react-shared/Notifications/Compass/MarkAsReadButton";
import { NotificationFilter } from "@circle-react-shared/Notifications/Compass/NotificationFilter";
import { NotificationSettingsButton } from "@circle-react-shared/Notifications/Compass/NotificationSettingsButton";
import { usePopoverPortalContext } from "@circle-react-uikit/PopoverPortal";
import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { IconButton } from "@circleco/compass/components/IconButton";
import { Tooltip } from "@circleco/compass/components/Tooltip";
import { Link } from "@tanstack/react-router";
import { isFunction } from "lodash";

import { t } from "@/i18n-js/instance";
import { useSmOrMdScreenMediaQuery } from "@/react/hooks/useMediaQuery";

import { RightActionBlockHeader } from "../RightActionBlockHeader";

interface HeaderProps {
  onClose?: () => void;
}

export const Header = ({ onClose }: HeaderProps) => {
  const isSmallScreen = useSmOrMdScreenMediaQuery();
  const { onClose: closePopover } = usePopoverPortalContext();
  const { currentCommunitySettings } = usePunditUserContext();
  const isNotificationsTabV2Enabled = Boolean(
    currentCommunitySettings?.live_pulse_notifications_tab_v2_enabled,
  );

  return (
    <RightActionBlockHeader
      title={t("header_v3.notifications")}
      actions={
        <>
          {isNotificationsTabV2Enabled && <NotificationFilter />}
          <MarkAsReadButton />
          {!isSmallScreen && (
            <Tooltip content={t("header_v3.open_in_full_page")}>
              <Link to="/notifications" onClick={() => closePopover?.()}>
                <IconButton
                  icon="square-arrow-top-right"
                  size="md"
                  variant="ghost"
                  aria-label={t("header_v3.open_in_full_page")}
                />
              </Link>
            </Tooltip>
          )}
          <NotificationSettingsButton />
          {isFunction(onClose) && (
            <Tooltip content={t("header_v3.close")}>
              <IconButton
                icon="cross"
                size="md"
                variant="ghost"
                onClick={onClose}
                aria-label={t("header_v3.close")}
              />
            </Tooltip>
          )}
        </>
      }
    />
  );
};
